<div class="form-group">
  <div class="row align-items-center">
    <div class="col-12">
      <div *ngIf="!confirmTypeIsBackoffice() && !this.request.reply.replyItems[this.Index].isDone" class="font-weight-bold mb-2">{{'doctrine.solution.action_confirm.dealer_choice'|translate}}</div>
      <div *ngIf="confirmTypeIsBackoffice() && !this.request.reply.replyItems[this.Index].isDone" class="font-weight-bold mb-2">{{'doctrine.solution.action_confirm.please_choose'|translate}}</div>
      <div *ngIf="confirmTypeIsBackoffice() && this.request.reply.replyItems[this.Index].isDone" class="font-weight-bold mb-2">{{'doctrine.solution.action_confirm.backoffice_choice'|translate}}</div>
      <div class="mb-2">{{request.reply.replyItems[Index].solutionStep.actionConfirm.message}}</div>
      <div class="form-radio d-flex">
        <div class="radio radio-inline">
          <label>
            <input type="radio" [name]="'confirmation_nextStep'+Index" [disabled] = "request.reply.replyItems[Index].isDone" value="primary" [(ngModel)]="selectedOption">
            <i class="helper"></i>{{request.reply.replyItems[Index].solutionStep.actionConfirm.primaryOption}}
          </label>
        </div>
        <div class="radio radio-inline">
          <label>
            <input type="radio" [name]="'confirmation_nextStep'+Index" [disabled] = "request.reply.replyItems[Index].isDone" value="secondary" [(ngModel)]="selectedOption">
            <i class="helper"></i>{{request.reply.replyItems[Index].solutionStep.actionConfirm.secondaryOption}}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
<button *ngIf="!request.reply.replyItems[Index].isDone"
 [disabled]="!selectedOption || request.isArchived" class="btn btn-primary ripple light pull-right my-3" (click)="confirmStep()" type="button">{{'global.send'|translate}}</button>
